export const SET_CARDS = "SET_CARDS";
export const SET_BUSINESS = "SET_BUSINESS";
export const SET_SLOTS = "SET_SLOTS";
export const SET_MY_ACCOUNT_VIEW_STATUS = "SET_MY_ACCOUNT_VIEW_STATUS";
export const SET_SECURITY_PERMITS = "SET_SECURITY_PERMITS";
